import React, { forwardRef, useImperativeHandle, useRef, } from 'react';
import styled from 'styled-components';
import { useUniqueId } from '../utils/id';
import { Fieldset } from '../fields/Fieldset';
import { ITEM_GAP } from './constants';
import { RadioItem } from './RadioItem';
const RadioGroupComponent = ({ options, onChange, onBlur, value, displayType = 'normal', renderAsTitle = false, error = false, fallbackStyle = false, justifyContent, itemWidth, ...fieldProps }, ref) => {
    const name = useUniqueId();
    const optionRefs = useRef([]);
    useImperativeHandle(ref, () => {
        return {
            focus: () => {
                const selectedIndex = options.findIndex((item) => item.value === value);
                const elementToFocus = selectedIndex === -1 ? 0 : selectedIndex;
                optionRefs.current[elementToFocus].current?.focus();
            },
        };
    });
    return (React.createElement(Fieldset, { renderAsTitle: renderAsTitle, error: error, ...fieldProps },
        React.createElement(RadioItemList, { "$displayType": displayType, "$justifyContent": justifyContent }, options.map((option, index) => {
            const isSelected = option.value === value;
            return (React.createElement(RadioItem, { ref: (radioOptionRef) => {
                    optionRefs.current[index] = {
                        current: radioOptionRef,
                    };
                }, key: `${option.value}`, name: name, visual: option.visual, icon: option.icon, iconPosition: option.iconPosition, label: option.label, value: option.value, checked: isSelected, 
                // @ts-expect-error TODO: address this type inconsistency in another PR
                onChange: onChange, onBlur: onBlur, displayType: displayType, isError: error, fallbackStyle: fallbackStyle, bodyCopy: option.bodyCopy, disabled: option.disabled, itemWidth: itemWidth }));
        }))));
};
export const RadioGroup = forwardRef(RadioGroupComponent);
const RadioItemList = styled.div `
  display: flex;
  gap: ${ITEM_GAP}px;

  ${({ $displayType }) => {
    if ($displayType === 'horizontal-card') {
        return `
        flex-direction: row;
        flex-wrap: wrap;
      `;
    }
    return `flex-direction: column;`;
}}
  justify-content: ${({ $justifyContent }) => $justifyContent ?? 'flex-start'};
`;
//# sourceMappingURL=RadioGroup.js.map